import axios from "axios";
import { useQuery } from "react-query";
import { API_ENDPOINT, APP_ID } from "../../../../constants/constants";

const useGetFormEdit = () => {
  return useQuery({
    queryKey: ["get-form-edit"],
    queryFn: async () => {
      const response = await axios.get(`${API_ENDPOINT}event/get-form-edit`, {
        headers: {
          dbauth: APP_ID, // Send token securely in headers
        },
      });
      return response.data;
    },
    retry: (failureCount, error) => {
      if (!error.response) return true; // Retry on network errors
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500; // No retries for 404/500
    },
  });
};

export default useGetFormEdit;
